import React, { FC, ReactNode } from 'react';
import { Button, Tooltip } from '@mui/material';

import useStyles from './styles';

interface IProps {
  tooltip: string;
  icon: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

const Action: FC<IProps> = ({ tooltip, icon, disabled, onClick }) => {
  const classes = useStyles();

  return (
    <Tooltip title={tooltip} className={classes.action}>
      <Button
        className={disabled ? classes.actionDisabled : classes.actionEnabled}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          onClick?.();
        }}
      >
        {icon}
      </Button>
    </Tooltip>
  );
};

export default Action;
